import { Navigate, useLocation } from 'react-router-dom';

/** Legacy `/social/settings` → unified module settings master. */
export function SocialSettingsLegacyRedirect() {
  const location = useLocation();
  return (
    <Navigate to={`/settings/communication/social-settings${location.search}`} replace />
  );
}
